import React from "react";
import { Box, Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

/**
 * Full-size image viewer. We can't just window.open() a data: URL anymore —
 * Chrome blocks top-frame navigation to data URLs as of ~M84. Rendering the
 * image inside a Dialog instead keeps it in-app and lets users see the full
 * resolution chart with a backdrop click to dismiss.
 */

interface Props {
  src: string | null;
  onClose: () => void;
}

export const ImageLightbox: React.FC<Props> = ({ src, onClose }) => {
  return (
    <Dialog
      open={!!src}
      onClose={onClose}
      maxWidth={false}
      sx={{ zIndex: 2100 }}
      PaperProps={{
        sx: {
          backgroundColor: "rgba(0,0,0,0.92)",
          boxShadow: "none",
          m: 2,
          maxWidth: "calc(100vw - 32px)",
          maxHeight: "calc(100vh - 32px)",
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "white",
            backgroundColor: "rgba(0,0,0,0.4)",
            "&:hover": { backgroundColor: "rgba(0,0,0,0.6)" },
            zIndex: 1,
          }}
          size="small"
        >
          <CloseIcon />
        </IconButton>
        {src && (
          <Box
            component="img"
            src={src}
            alt="chart"
            sx={{
              display: "block",
              maxWidth: "calc(100vw - 64px)",
              maxHeight: "calc(100vh - 64px)",
              width: "auto",
              height: "auto",
            }}
          />
        )}
      </Box>
    </Dialog>
  );
};
